export * from './IconRemove';
